import { useLocalStorage } from "@circle-react/hooks/utils/useLocalStorage";

interface UseCommentsPersistentCacheParams {
  postId: string | number;
  parentCommentId: string | number | null;
}

export const useCommentsPersistentCache = ({
  postId,
  parentCommentId,
}: UseCommentsPersistentCacheParams) => {
  const persistCacheKey = parentCommentId
    ? `post-${postId}-comment-${parentCommentId}-reply-form-values`
    : `post-${postId}-comment-form-values`;

  const { resetValue } = useLocalStorage(persistCacheKey);

  return {
    persistCacheKey,
    resetPersistedFormValues: resetValue,
  };
};
